export default function($) {
  var speed = 90; // ms

  function applyDropdownBehavior() {
    $('.suggestion-dropdown-wrapper').each(function(index) {
      if (index === 0) {
        $(this).find('.js-suggestion-dropdown').show();
        if ($(window).width() > 769) {
          $(this).find('.js-suggestion-summary').hide();
        } else {
          $(this).find('.js-suggestion-summary').show();
          $(this).addClass('open');
        }
      } else {
        $(this).find('.js-suggestion-dropdown').hide();
        $(this).find('.js-suggestion-summary').show();
      }
    });
  }

  applyDropdownBehavior();

  $('.js-suggestion-dropdown-button').click(function() {
    var wrapper = $(this).closest('.suggestion-dropdown-wrapper');
    var dropdown = wrapper.find('.js-suggestion-dropdown');
    var isOpen = wrapper.hasClass('open');

    $('.js-suggestion-dropdown').not(dropdown).slideUp(speed);
    $('.js-suggestion-summary').not('.js-suggestion-summary').show();
    $('.suggestion-dropdown-wrapper.open').not(wrapper).removeClass('open');

    dropdown.slideToggle(speed);

    if ($(window).width() > 769) {
      $('.js-suggestion-summary').toggle();
    } else {
      $('.js-suggestion-summary').show();
      wrapper.toggleClass('open', !isOpen);
    }
  });
}
